import Vue from 'vue'
import Vuex from 'vuex'
import profile from './modules/profile'
import customize from './modules/customize'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    profile,
    customize
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js